import React, { useState, useEffect } from 'react'
import Button from 'components/Button/Button'
import { Input } from 'components/Input'
import TextArea from 'components/TextArea/TextArea'
import FacilityFormTemplate from 'templates/FacilityFormTemplate'
import {
  TextOutreachButtonContainer,
  TextOutreachContainer,
  TextOutreachInputContainer,
} from './TextOutreach.styled'
import cogoToast from 'cogo-toast'
import { useAppDispatch, useAppState } from 'store'
import { outreachActions } from 'store/slices/outreach'
import { useParams } from 'react-router'
import { Location } from 'models/location'
import Spinner from 'components/Spinner'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'

const TextOutreachPage = () => {
  const params: Location = useParams()
  const dispatch = useAppDispatch()
  const [recipients, setRecipients] = useState<string>()
  const [body, setBody] = useState<string>()
  const { messageStatus } = useAppState(state => state.outreach)
  const { logEvent } = useAmplitude()

  useEffect(() => {
    logEvent(AMPLITUDE_EVENTS.TEXT_OUTREACH_PAGE_EVENT, { location: params.locationId })
  }, [])

  const handleSendMessage = () => {
    if (body && recipients) {
      dispatch(
        outreachActions.sendMessages({
          locationId: params ? params.locationId : '',
          body: { recipients, body },
        })
      )
    } else {
      cogoToast.error('Recipients and body fields are required.', {
        position: 'top-right',
      })
    }
  }

  return (
    <FacilityFormTemplate>
      {messageStatus === 'loading' && <Spinner />}
      {messageStatus !== 'loading' && (
        <TextOutreachContainer>
          <TextOutreachInputContainer>
            <Input
              label={'From'}
              placeholder="from"
              defaultValue="212-555-1234"
              disabled
            />
            <Input
              label={'Recipients'}
              placeholder="Cohort, program, or phone number"
              onTextChange={setRecipients}
              required
            />
          </TextOutreachInputContainer>

          <TextArea
            label="Body"
            size={96}
            required
            maxLength={150}
            onTextChange={setBody}
          />
          <TextOutreachButtonContainer>
            <Button
              preset="filled"
              variant="primary"
              text="Send Messages"
              onClick={handleSendMessage}
              size={'medium'}
            />
          </TextOutreachButtonContainer>
        </TextOutreachContainer>
      )}
    </FacilityFormTemplate>
  )
}

export default TextOutreachPage
